import { Route } from "react-router-dom";
import Header from "../../landing/Header";

const RouteWithHeader = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <>
        <Header />
        <Component {...props} />
      </>
    )}
  />
);

export default RouteWithHeader;
